import { SearchFieldMetadata } from "../../../features/search/api/search-metadata.types";

// eslint-disable-next-line no-unused-vars
export type FieldValidator = (value?: string) => true | string;

const DATE_PATTERN = /^(\d{2})\/(\d{2})\/(\d{4})$/;

export const validateDateOfBirth = (value?: string): true | string => {
  if (!value) return true;
  const match = value.match(DATE_PATTERN);
  if (!match) return "Please enter a valid date";

  const month = Number(match[1]);
  const day = Number(match[2]);
  const year = Number(match[3]);

  if (month < 1 || month > 12) return "Invalid month";

  const daysInMonth = new Date(year, month, 0).getDate();
  if (day < 1 || day > daysInMonth) {
    return month === 2 ? "Invalid day for February" : "Invalid day";
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  if (new Date(year, month - 1, day) >= today) {
    return "Date must be in the past";
  }

  return true;
};

/** Named rules the backend can reference from field metadata. */
const NAMED_RULES: Record<string, FieldValidator> = {
  dateOfBirth: validateDateOfBirth,
};

/** Turns declarative validation metadata into a react-hook-form validator. */
export const buildFieldValidator = (
  field: SearchFieldMetadata,
): FieldValidator => {
  const { validation } = field;

  return (value?: string) => {
    if (!value) return true;

    if (validation?.maxLength && value.length > validation.maxLength) {
      return (
        validation.maxLengthMessage ??
        `${field.label} must be ${validation.maxLength} characters or less`
      );
    }

    if (validation?.pattern && !new RegExp(validation.pattern).test(value)) {
      return validation.patternMessage ?? `${field.label} is invalid`;
    }

    if (validation?.rule) {
      const rule = NAMED_RULES[validation.rule];
      if (rule) return rule(value);
    }

    return true;
  };
};
